module.exports = __webpack_public_path__ + "static/media/delete.da8756dc.svg";